import script from "./AuditorTemplateSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditorTemplateSettings.vue?vue&type=script&setup=true&lang=js"

import "./AuditorTemplateSettings.vue?vue&type=style&index=0&id=1eddb80f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eddb80f"]])

export default __exports__